import { gql } from '@apollo/client';

export const UPDATE_DATA_IMPORTER = gql`
    mutation UpdateDataImporter($id: Guid!, $input: UpdateDataImporterPatch!) {
        facility {
            configurations {
                dataImporters {
                    updateImporter(id: $id, input: $input) {
                        name
                        type
                        description
                        isRestricted
                        configuration
                        state
                        isStateful
                    }
                }
            }
        }
    }
`;
